import { Store } from '@tanstack/react-store'

export type PaymentsList = {
  page: number
  size: number
  totalPages: number
  totalElements: number
  filter: PaymentsListFilter
  sort: PaymentsListSort
}

export const defaultPaymentsListState: PaymentsList = {
  page: 0,
  size: 50,
  totalPages: 0,
  totalElements: 0,
  filter: {},
  sort: {
    sortBy: {
      paymentDate: 'DESC',
    },
    sortOrder: ['paymentDate'],
  },
}

export const paymentsListStore = new Store(defaultPaymentsListState)

export const resetPaymentsList = () => {
  paymentsListStore.setState(defaultPaymentsListState)
}

export type PaymentsListFilter = {
  payeePhone?: string
  payerPhone?: string
  paymentAmountMax?: string
  paymentAmountMin?: string
  paymentDateFrom?: string
  paymentDateTo?: string
  paymentId?: string
  paymentState?: string
  payeeFIO?: string
  payeeCardNumber?: string
  paymentType?: string
  rrn?: string
}

export type PaymentsListSort = {
  sortBy: {
    paymentDate: 'DESC' | 'ASC'
  }
  sortOrder: string[]
}
